import { Component, OnInit } from '@angular/core';
import { ETenderViewDTO } from 'src/app/shared/models/e-tender.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { ActivatedRoute } from '@angular/router';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'app-view-tender',
  templateUrl: './view-tender.component.html',
  styles: []
})
export class ViewTenderComponent implements OnInit {
  model: ETenderViewDTO;
  private tenderRequestId = '';
  responseObj: ResponseObject;
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;

  constructor(
    private route: ActivatedRoute,
    private etenderSrv: EtenderService,
    private globalSrv: GlobalServices) {
      if (history.state.data && history.state.data.tenderId) {
        this.tenderRequestId = history.state.data.tenderId;
        this.setFormMode();
      } else {
        window.history.back();
      }
  }

  ngOnInit() {
  }
  // Form Mode
  setFormMode(): void {
    // Edit Mode / Display Mode
    if (this.tenderRequestId != null) {
      this.globalSrv.isLoaderEnabled = true;
      // Get Long Haul Request by Id
      this.getTenderRequest();
    }
  }
  getTenderRequest(): void {
    this.etenderSrv.GetTenderViewById(this.tenderRequestId, (this.globalSrv.getLanguage() == Languages.Arabic ? 'Ar' : 'En')).subscribe(
      data => {
        this.responseObj = data;
        this.getTenderRequestCompleted();
      },
      () => console.log('Something went wrong!!')
    );
  }
  getTenderRequestCompleted(): void {
    if (this.responseObj.Success) {
      this.model = this.responseObj.Data as ETenderViewDTO;
      if (this.model.BookletCopy != '') {
        this.model.BookletCopy = this.uploadUrl + this.model.BookletCopy;
      }
      this.globalSrv.isLoaderEnabled = false;
      // Disable Loader
    } else {
      // Enable Error
    }
  }
}
